// TINY SLIDER
import { tns } from "tiny-slider/src/tiny-slider"

export const CareerSlider = {
	selectors: {
		sliderSelector: Array.prototype.slice.call(document.querySelectorAll('.js-career-slider'))
	},

	init: function(state) {
		let self = this;

		self.selectors.sliderSelector.forEach(x => {
			var slider = tns({
				items: 1,
				mouseDrag: true,
				lazyload: true,
				container: x,
				swipeAngle: false,
				autoHeight: false,
				speed: 400,
				controls: true,
				controlsContainer: '.js-career-slider--controls',
				slideBy: 1,
				loop: false,
				responsive: {
					560: {
						edgePadding: 20,
						gutter: 20,
						items: 2
					}
				},
				onInit: function(slider) {
					let navIt = Array.prototype.slice.call(slider.navContainer.querySelectorAll('button'));
					slider.container.classList.add('is-init');
					slider.navContainer.classList.add('c-slider__nav');

					navIt.forEach(x => {
						x.classList.add('c-slider__nav-item')
					})
				}
			});
		});
	}
};

CareerSlider.init();



